export default __webpack_public_path__ + "static/media/mohit_mahajan.32aaa43a.jpeg";